module.exports = __webpack_public_path__ + "img/compact.dec433bd.png";